import React from "react";
import AllSubjectTopics from "../../../topics/AllSubjectTopics";


function FlashcardPhysTopics() {



  return (
    <>

      <AllSubjectTopics subject="physics" type="flashcard" />

    </>
  );
}

export default FlashcardPhysTopics;